<template>
  <div>
    <div v-if="availables && availables.length == 0">-</div>
    <v-layout>
      <template v-for="(available, index) in availables">
        <v-flex
          :key="index"
          @click="currentIndex = index"
          :class="{ 'primary--text': currentIndex == index }"
          style="cursor: pointer; text-transform: capitalize"
          >{{ available.day }}</v-flex
        ><v-flex v-if="index != availables.length - 1" :key="'split' + index">|</v-flex>
      </template>
    </v-layout>
    <template v-if="availables && availables[currentIndex]">
      <template v-for="(time, index) in availables[currentIndex].time">
        <v-chip class="white--text" color="primary" small disabled :key="time + '_' + index"
          >{{ time }} - {{ time | endtime(spendtime) }}</v-chip
        >
      </template>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: ['value', 'spendtime'],
  data() {
    return {
      currentIndex: 0
    }
  },
  filters: {
    endtime(val, time) {
      return moment(val, 'HH:mm')
        .add(moment.duration(parseInt(time), 'minutes'), 'minutes')
        .format('HH:mm')
    }
  },
  computed: {
    availables() {
      try {
        var day = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
        var availables = JSON.parse(this.value)
        return availables.reduce((prev, curr) => {
          if (curr.day == null || curr.day == '') {
            day.forEach((el) => {
              var tmp_curr = cloneDeep(curr)
              tmp_curr.day = el.toLowerCase()
              prev = this.fillAvailables(prev, tmp_curr)
            })
          } else {
            prev = this.fillAvailables(prev, curr)
          }
          return prev
        }, [])
      } catch (error) {
        return []
      }
    }
  },
  methods: {
    fillAvailables(prev, curr) {
      var index = prev.findIndex((el) => {
        return el.day == curr.day
      })
      if (index != -1) {
        prev[index].time.push(curr.start)
      } else {
        prev.push({
          day: curr.day,
          time: [curr.start]
        })
      }
      return prev
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/AvailableTable.vue